import { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { noop } from 'lodash';
import React, { FC, PropsWithChildren, createContext, useContext, useState } from 'react';

export type PublisherType = 'POST' | 'QUESTION';

interface PostCreateModalContextProps {
  readonly showContent: () => void;
  readonly hideContent: () => void;
  readonly publisherType: PublisherType | null;
  readonly setPublisherType: (type: PublisherType | null) => void;
}

const defaultPostCreateModalContext: PostCreateModalContextProps = {
  showContent: noop,
  hideContent: noop,
  publisherType: null,
  setPublisherType: noop,
};

export const PostCreateModalContext = createContext<PostCreateModalContextProps>(defaultPostCreateModalContext);

export const useShowPostCreateModal = () => useContext<PostCreateModalContextProps>(PostCreateModalContext).showContent;
export const useHidePostCreateModal = () => useContext<PostCreateModalContextProps>(PostCreateModalContext).hideContent;
export const usePostCreateModalContext = () => useContext(PostCreateModalContext);

export interface CreatePostProviderProps {
  readonly usePostCreateModal: () => ReturnType<typeof useRenderToggleableContent>;
}

export const CreatePostProvider: FC<PropsWithChildren<CreatePostProviderProps>> = ({
  usePostCreateModal,
  children,
}) => {
  const [publisherType, setPublisherType] = useState<PublisherType | null>(null);
  const { showContent, hideContent, content } = usePostCreateModal();

  return (
    <PostCreateModalContext.Provider value={{ showContent, hideContent, publisherType, setPublisherType }}>
      {children}
      {content}
    </PostCreateModalContext.Provider>
  );
};
